// extracted by mini-css-extract-plugin
export var text = "renderer-module--text--uXtwy";
export var fadein = "renderer-module--fadein--t-5m7";